<div class="relative">
  <app-tooltip content="Send feedback" placement="bottom">
  <button
    class="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full dropdown-toggle hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    (click)="toggle()"
    aria-label="Send feedback"
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M12 2C8.13401 2 5 5.13401 5 9C5 11.3864 6.19378 13.4905 8.01445 14.7639C8.00487 14.8421 8 14.9207 8 15V17C8 17.5523 8.44772 18 9 18H10V19C10 19.5523 10.4477 20 11 20H13C13.5523 20 14 19.5523 14 19V18H15C15.5523 18 16 17.5523 16 17V15C16 14.9207 15.9951 14.8421 15.9856 14.7639C17.8062 13.4905 19 11.3864 19 9C19 5.13401 15.866 2 12 2ZM10 15V16H14V15C14 14.4477 14.4477 14 15 14L15 14.0023C13.9159 13.3878 13.1536 12.2848 13.0227 11H10.9773C10.8464 12.2848 10.0841 13.3878 9.00012 14.0023L9 14C9.55228 14 10 14.4477 10 15ZM10.9773 9C10.9773 9 11 9.5 11 10H13C13 9.5 13.0227 9 13.0227 9H10.9773ZM12 4C9.23858 4 7 6.23858 7 9C7 10.6569 7.83501 12.1152 9.10571 13H14.8943C16.165 12.1152 17 10.6569 17 9C17 6.23858 14.7614 4 12 4ZM11 18V19H13V18H11Z"
        fill="currentColor" />
    </svg>
  </button>
  </app-tooltip>

  <app-dropdown
    [isOpen]="isOpen"
    (close)="close()"
    className="absolute right-0 mt-[17px] w-80 rounded-2xl border border-gray-200 bg-white p-4 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
  >
    @if (!submitted) {
      <div class="mb-3">
        <h5 class="text-base font-semibold text-gray-800 dark:text-gray-200">Send Feedback</h5>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Tell us what you think or report an issue.</p>
      </div>
      <textarea
        [(ngModel)]="feedbackText"
        rows="4"
        placeholder="Describe what you're seeing..."
        class="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 resize-none"
      ></textarea>
      <button
        (click)="submit()"
        [disabled]="!canSubmit()"
        class="mt-3 w-full rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        @if (isSubmitting) {
          Submitting...
        } @else {
          Submit Feedback
        }
      </button>
    } @else {
      <div class="flex flex-col items-center py-4 text-center">
        <svg class="mb-2 text-success-500" width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289C16.3166 7.90237 15.6834 7.90237 15.2929 8.29289L10.5 13.0858L8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L9.79289 15.2071C10.1834 15.5976 10.8166 15.5976 11.2071 15.2071L16.7071 9.70711Z"
            fill="currentColor" />
        </svg>
        <p class="text-sm font-medium text-gray-800 dark:text-gray-200">Thanks for your feedback!</p>
        <button
          (click)="close()"
          class="mt-3 text-sm text-brand-500 hover:underline"
        >Close</button>
      </div>
    }
  </app-dropdown>
</div>
